import React, { useEffect, useState } from "react";
import { navigate } from "gatsby";

import { COLORS } from "../../../../utils/colors";

import ICONS from "../../../../constants/icons";
import MENU_PATHS from "../../../../constants/menu";

import MenuItems from "../menuItems";
import { IconButton } from "../../../buttons";

const Sidebar = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    window.addEventListener("resize", () => setOpen(false));

    return () => {
      window.removeEventListener("resize", () => setOpen(false));
    };
  }, []);

  const handleClick = () => setOpen(!open);
  return (
    <div
      className={`m-sidebar ${open ? "-open" : ""}`}
      style={{
        background: `linear-gradient(96.19deg, ${COLORS.linearBackgroundLightBlue} 4.89%, ${COLORS.linearBackgroundDarkBlue} 54.96%)`,
      }}
    >
      <div className={`m-sidebar__top ${open ? "-mobile" : ""}`}>
        <div></div>
        <IconButton
          handleClick={() => navigate(MENU_PATHS.HOMEPAGE)}
          name={ICONS.LOGO}
          aria={{
            label: "Logo image"
          }}
        />
        <div
          className="m-sidebar__top--hamburger"
          onClick={handleClick}
          role="menu"
          tabIndex={0}
        >
          <span role="menuitem" aria-label="Responsive menu item"></span>
          <span role="menuitem" aria-label="Responsive menu item"></span>
          <span role="menuitem" aria-label="Responsive menu item"></span>
        </div>
      </div>
      <div className={`m-sidebar__bottom ${open ? "-open" : ""}`}>
        <div className="m-sidebar__bottom--wrapper">
          <MenuItems setOpen={setOpen} />
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
